import configureStore from "./store";

// Singleton store instance reused across app and any dynamically mounted components.
export const store = configureStore();
